var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pos-rel",staticStyle:{"background":"#000"}},[_c('div',{staticClass:"padding-10"},[_c('div',{staticClass:"pos-rel"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/images/bg-bottom.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad1e067","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/homepage/components/md/cooperation.vue
// module id = null
// module chunks = 